'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _header = require('./header');

var _header2 = _interopRequireDefault(_header);

var _brand = require('./brand');

var _brand2 = _interopRequireDefault(_brand);

var _exhibitorListing = require('./exhibitor-listing');

var _exhibitorListing2 = _interopRequireDefault(_exhibitorListing);

var _showLocations = require('./show-locations');

var _showLocations2 = _interopRequireDefault(_showLocations);

var _locationItem = require('./location-item');

var _locationItem2 = _interopRequireDefault(_locationItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/** @class Naviation
  * A component encapsulating all the navigation
  * components for a virtual expo.
  * @param {string} name - the name of the show
  * @param {Object} halls - the halls in the show
  * @param {Object} booths - the booths in the show
  * @param {bool} isSample - indicates if the show does not use authentication
  * @param {URLString} exhibitorListingBackground - image url for exhibitor listing background
  * @param {URLString} showLocationBackground - image url for show location background
  */
var Navigation = function (_Component) {
  _inherits(Navigation, _Component);

  /** @constructor
    * Constructs a new navigation instance
    */
  function Navigation(props) {
    _classCallCheck(this, Navigation);

    var _this = _possibleConstructorReturn(this, (Navigation.__proto__ || Object.getPrototypeOf(Navigation)).call(this, props));

    _this.state = {
      locationName: ""
    };
    return _this;
  }

  _createClass(Navigation, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      if (!window.vexpo) window.vexpo = {};
      if (!window.vexpo.navigation) window.vexpo.navigation = {
        setLocationName: function setLocationName(name) {
          _this2.setState({ locationName: name });
        }
      };
    }
    /** @method render
      * Renders the navigation component.
      */

  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_header2.default, { name: this.props.name, icon: this.props.icon, location: this.state.locationName }),
        _react2.default.createElement(_exhibitorListing2.default, { name: this.props.name, supportEmail: this.props.supportEmail, booths: this.props.booths, background: this.props.exhibitorListingBackground }),
        _react2.default.createElement(_showLocations2.default, { name: this.props.name, supportEmail: this.props.supportEmail, halls: this.props.halls, background: this.props.showLocationsBackground })
      );
    }
  }]);

  return Navigation;
}(_react.Component);

exports.default = Navigation;


Navigation.propTypes = {
  name: _propTypes2.default.string.isRequired,
  halls: _propTypes2.default.object.isRequired,
  booths: _propTypes2.default.object.isRequired,
  isSample: _propTypes2.default.bool.isRequired,
  exhibitorListingBackground: _propTypes2.default.string.isRequired,
  showLocationsBackground: _propTypes2.default.string.isRequired
};


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/navigation/navigation.js
// module id = 688
// module chunks = 0